"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.beautifyField = exports.normalize = void 0;
exports.underscore = underscore;
exports.capitalize = capitalize;
exports.pascalToCamelCase = pascalToCamelCase;
function underscore(s) {
    return s
        .replace(/::/g, '/')
        .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
        .replace(/([a-z\d])([A-Z])/g, '$1_$2')
        .replace(/-/g, '_')
        .toLowerCase();
}
function capitalize(s) {
    var firstChar = s[0];
    var restOfStr = s.slice(1);
    return "".concat(firstChar.toUpperCase()).concat(restOfStr);
}
var normalize = function (str) {
    var normalizationRegexp = /[^a-z0-9]+/g;
    var normalizedString = str.toLowerCase().replace(normalizationRegexp, '');
    return normalizedString;
};
exports.normalize = normalize;
function pascalToCamelCase(s) {
    var firstChar = s[0];
    var restOfStr = s.slice(1);
    return "".concat(firstChar.toLowerCase()).concat(restOfStr);
}
var beautifyField = function (fieldName) {
    var result = underscore(fieldName).replace(/_/g, ' ');
    result = result
        .split(/(\d+)/g)
        .filter(function (s) { return s.trim() !== ''; })
        .join(' ');
    return capitalize(result);
};
exports.beautifyField = beautifyField;
//# sourceMappingURL=string.js.map